// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2b8cc878","834":"4ff7bdd0","848":"39195eb0","975":"83e01f30"}[chunkId] + ".chunk.js";
};